import { jsx as r } from "react/jsx-runtime";
import { Flex as i, Switch as s } from "@chakra-ui/react";
import l from "react";
import { hoverStyles as a } from "./hover-styles.js";
const n = l.forwardRef(
  ({
    size: t = "md",
    display: e = "flex",
    alignItems: o = "center",
    justifyContent: f = "flex-start",
    ...m
  }, c) => /* @__PURE__ */ r(i, { __css: a, children: /* @__PURE__ */ r(
    s,
    {
      size: t,
      display: e,
      alignItems: o,
      justifyContent: f,
      ref: c,
      ...m
    }
  ) })
);
export {
  n as Switch
};
